import React from 'react';
import Progressions from './Progressions';

const DropdownSelector = ({ 
  selectedScale, 
  showScaleDropdown, 
  setShowScaleDropdown, 
  changeScale 
}) => {
  const scales = Object.entries(Progressions).filter(([_, item]) => item.type === 'scale');
  const songs = Object.entries(Progressions).filter(([_, item]) => item.type === 'song');
  const exercises = Object.entries(Progressions).filter(([_, item]) => item.type === 'exercise');

  return (
    <div className="relative mb-4 z-40 flex flex-col items-center">
      <button
        onClick={() => setShowScaleDropdown(!showScaleDropdown)}
        className="flex items-center justify-between px-4 py-2 bg-white text-gray-800 rounded-lg shadow-md text-xl font-bold m-w-[200px]"
      >
        <div className="flex items-center">
          {Progressions[selectedScale]?.type === 'song' && (
            <img 
              src={`./img/${Progressions[selectedScale].coverUrl}.png`} 
              alt={selectedScale}
              className="w-8 h-8 mr-2 rounded border border-gray-300"
            />
          )}

          {Progressions[selectedScale]?.type === 'scale' && (
            <i className={`fa-solid fa-circle ${Progressions[selectedScale]?.color || 'text-gray-600'} mr-2`}></i>
          )}

          {Progressions[selectedScale]?.type === 'exercise' && (
            <i className="fa-solid fa-hand text-orange-500 mr-2"></i>
          )}

          {Progressions[selectedScale]?.type === 'scale' ? (
            <>Escala: {selectedScale}</>
          ) : (
            selectedScale
          )}
        </div>

        <i className={`ml-4 fa-solid ${showScaleDropdown ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
      </button>

      {showScaleDropdown && (
        <div className="absolute top-full mt-1 bg-white rounded-lg shadow-lg z-50 overflow-hidden max-h-[70vh] overflow-y-auto w-[900px] left-1/2 transform -translate-x-1/2">
          <div className="grid grid-cols-1 md:grid-cols-3 divide-x divide-gray-200">
            <div className="p-2">
              <h3 className="font-bold text-lg mb-2 text-center text-blue-600 border-b border-blue-200 pb-1">
                <i className="fa-solid fa-music mr-2"></i>Escalas
              </h3>
              {scales.map(([key, chordsInfo]) => (
                <button
                  key={key}
                  onClick={() => changeScale(key)}
                  className={`flex items-center w-full px-3 py-2 text-left hover:bg-gray-100 rounded ${
                    selectedScale === key ? 'bg-blue-100 text-blue-800 font-medium' : 'text-gray-700'
                  }`}
                >
                  <i className={`fa-solid fa-circle ${chordsInfo.color || 'text-gray-600'} mr-2`}></i>
                  {chordsInfo.name}
                </button>
              ))}
            </div>

            <div className="p-2">
              <h3 className="font-bold text-lg mb-2 text-center text-purple-600 border-b border-purple-200 pb-1">
                <i className="fa-solid fa-compact-disc mr-2"></i>Canciones
              </h3>
              {songs.map(([key, chordsInfo]) => (
                <button
                  key={key}
                  onClick={() => changeScale(key)}
                  className={`flex items-center w-full px-3 py-2 text-left hover:bg-gray-100 rounded ${
                    selectedScale === key ? 'bg-purple-100 text-purple-800 font-medium' : 'text-gray-700'
                  }`}
                >
                  <img 
                    src={`./img/${chordsInfo.coverUrl}.png`}
                    alt={chordsInfo.name}
                    className="w-6 h-6 mr-2 rounded border border-gray-300"
                  />
                  {chordsInfo.name}
                </button>
              ))}
            </div>

            <div className="p-2">
              <h3 className="font-bold text-lg mb-2 text-center text-orange-600 border-b border-orange-200 pb-1">
                <i className="fa-solid fa-hand mr-2"></i>Ejercicios
              </h3>
              {exercises.map(([key, chordsInfo]) => (
                <button
                  key={key}
                  onClick={() => changeScale(key)}
                  className={`flex items-center w-full px-3 py-2 text-left hover:bg-gray-100 rounded ${
                    selectedScale === key ? 'bg-orange-100 text-orange-800 font-medium' : 'text-gray-700'
                  }`}
                >
                  <i className="fa-solid fa-hand text-orange-500 mr-2"></i>
                  {chordsInfo.name}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DropdownSelector;